import React from 'react';
import styled from 'styled-components';
import { Switch } from '@mui/material';
import Typo from '../Typo';
import theme from '../theme';

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 8px 0;
  gap: 4px;
`;

const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
`;

const StatusText = styled.span`
  font-size: 11px;
  color: ${theme.colors.NEU_600};
  min-width: 50px;
`;

/**
 * SwitchRow - A reusable toggle switch row component
 * Displays a label with a switch toggle and status text
 *
 * @param {Object} props
 * @param {string} props.label - The label text for the switch
 * @param {boolean} props.checked - Whether the switch is on
 * @param {Function} props.onChange - Callback when switch is toggled (receives event)
 * @param {string} props.enabledText - Text to show when enabled (default: 'Enabled')
 * @param {string} props.disabledText - Text to show when disabled (default: 'Disabled')
 * @param {boolean} props.showStatus - Whether to show status text (default: true)
 * @param {string} props.size - Switch size: 'small' | 'medium' (default: 'small')
 */
const SwitchRow = ({ label, checked, onChange, enabledText = 'Enabled', disabledText = 'Disabled', showStatus = true, size = 'small' }) => {
  return (
    <Row>
      <Typo.SmallText>{label}</Typo.SmallText>
      <SwitchContainer>
        <Switch size={size} checked={checked} onChange={onChange} inputProps={{ 'aria-label': label }} />
        {showStatus && <StatusText>{checked ? enabledText : disabledText}</StatusText>}
      </SwitchContainer>
    </Row>
  );
};

export default SwitchRow;
